export const umbrellaEndpoints = {
    bulkActions: {
        discountCoupon: {
            assign: {
                api: '/api/umbrella/promotion/single-use-promotion/bulk-assignment',
                method: 'POST',
                parameter: false
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/umbrella.endpoints.ts